import { VISUAL_03 } from "../../data/reportContent";

export const Visual03 = () => (
  <section id={VISUAL_03.id} className="visual-block" data-testid="visual-03-section">
    <div className="visual-head">
      <span className="report-kicker">{VISUAL_03.number}</span>
      <h2>{VISUAL_03.title}</h2>
      <p>{VISUAL_03.intro}</p>
      <div className="effort-badge" data-testid="visual-03-effort-badge">
        Effort commitment: ~2½ volunteer days per month
      </div>
    </div>

    <div className="v3-track" data-testid="visual-03-track">
      {VISUAL_03.horizons.map((h, i) => (
        <div className="v3-horizon" key={h.title} data-testid={`visual-03-horizon-${i + 1}`}>
          <div className="v3-horizon-range">{h.range}</div>
          <h3>{h.title}</h3>
          <div className="v3-horizon-kicker">{h.kicker}</div>

          {h.actions && (
            <ul>
              {h.actions.map((a) => (
                <li key={a}>{a}</li>
              ))}
            </ul>
          )}

          {h.operatingRule && (
            <ul>
              <li>{h.operatingRule}</li>
            </ul>
          )}

          {h.measures && (
            <ul>
              {h.measures.map((m) => (
                <li key={m}>{m}</li>
              ))}
            </ul>
          )}

          {h.proof && (
            <div className="v3-proof">
              <strong>Proof</strong>
              {h.proof}
            </div>
          )}

          {h.gate && (
            <div className="v3-gate">
              <strong className="v3-gate-label">Decision gate</strong>
              {h.gate}
            </div>
          )}

          {h.retire && (
            <div className="v3-retire">
              <strong>Retire if proved</strong>
              {h.retire.join(" · ")}
            </div>
          )}

          {h.sequence && (
            <div className="v3-proof">
              <strong>Sequence</strong>
              {h.sequence}
            </div>
          )}

          {i < VISUAL_03.horizons.length - 1 && <span className="v3-arrow">→</span>}
        </div>
      ))}
    </div>

    <div className="v3-northstar" data-testid="visual-03-northstar">
      <p className="q">{VISUAL_03.horizons[3].finalQuestion}</p>
      <p className="note">{VISUAL_03.horizons[3].northStarNote}</p>
    </div>
  </section>
);
